import styled from "styled-components"
import { SvgComponent } from "@/components/base/Svg"
import Image from "@/components/base/Image"
import { Link } from "react-router-dom"
const FollowContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12rem;
    margin-top: 24rem;
`
const FollowItem = styled(Link)`
    border-radius: 8rem;
    padding: 12rem;
    background-color: #ffffff;
    display: grid;
    align-items: center;
    grid-template-columns: 24rem 1fr 24rem;
    gap: 12rem;
    margin-left: 16rem;
    margin-right: 16rem;
    text-decoration: none;
    color: #000000;
`

const FollowIcon = styled.div`
    width: 24rem;
    height: 24rem;
    & svg {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    & img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`
const FollowTitle = styled.div`
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 16rem;
    letter-spacing: 0%;
`

const FollowRightArrow = styled(SvgComponent("pages/UserCenterPage/right_arrow1.svg"))`
    width: 24rem;
    height: 24rem;
`

export default function Followus() {
    const icons = [
        {
            icon: "pages/HomePage/img_fb.webp",
            title: "Official Facebook Page",
            link: "https://www.facebook.com/filbet6/",
        },
        {
            icon: "pages/HomePage/img_fb.webp",
            title: "Facebook Group (Private)",
            link: "https://www.facebook.com/groups/filbetph.official",
        },
        {
            icon: "pages/HomePage/img_ig.webp",
            title: "Official Instagram",
            link: "https://www.instagram.com/filbet01/",
        },
        { icon: "pages/HomePage/img_x.webp", title: "X (Twitter)", link: "https://x.com/Filbet_6" },
        {
            icon: "pages/HomePage/img_tk.webp",
            title: "TikTok",
            link: "https://www.tiktok.com/@filbet.com",
        },
        {
            icon: "pages/HomePage/img_tg.webp",
            title: "Official Telegram",
            link: "https://t.me/+UUcXz17rZkw2MzY1",
        },
        {
            icon: "pages/HomePage/img_viber.webp",
            title: "Official Viber Bot",
            link: "https://www.viber.com/filbet",
        },
    ] as const

    return (
        <FollowContainer>
            {icons.map(({ icon, title, link }, index) => (
                <FollowItem
                    to={link}
                    target="_blank"
                >
                    <FollowIcon key={index}>
                        <Image src={icon} />
                    </FollowIcon>

                    <FollowTitle>{title}</FollowTitle>

                    <FollowRightArrow />
                </FollowItem>
            ))}
        </FollowContainer>
    )
}
